import { Modal, styled } from '@mui/material';

export const CenteredModal = styled(Modal)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 999998,
}));
